import { createFileRoute } from "@tanstack/react-router";
import { AttendanceScanner } from "@/components/portal/attendance-scanner";
import { requirePortalFeature } from "@/lib/portal-data";

/**
 * The scanner. Also the target of the QR code itself — the code is
 * `/portal/attendance/scan?s=<session>&t=<token>`, so scanning it with a phone's
 * own camera app opens this page (through sign-in if needed) and checks in.
 */
export const Route = createFileRoute("/portal/attendance/scan")({
  validateSearch: (search: Record<string, unknown>): { s?: string; t?: string } => ({
    s: typeof search.s === "string" ? search.s : undefined,
    t: typeof search.t === "string" ? search.t : undefined,
  }),
  beforeLoad: ({ context }) => requirePortalFeature(context.queryClient, "attendance"),
  component: ScanPage,
});

function ScanPage() {
  const { s, t } = Route.useSearch();
  // Read once: the scanner clears the code from the URL after using it.
  const initial = s && t ? { sessionId: s, token: t } : null;
  return <AttendanceScanner initialCode={initial} />;
}
